function isiOS(){return"undefined"!=typeof navigator&&(/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document)}export{isiOS};
//# sourceMappingURL=isiOS.js.map
